import xss from 'xss';

import popsss from 'lib/popsss';

import { ACTION_TYPES } from '../constants';

// ---------------------------------
// Question related action creators:
// ---------------------------------

export function addQuestionStart(category) {
  return {
    type: ACTION_TYPES.ADD_QST_START,
    category,
  };
}

export function addQuestionSuccessful(category, question) {
  return {
    type: ACTION_TYPES.ADD_QST_SUCCESSFUL,
    category,
    question,
  };
}

export function addQuestionFailed(category, error) {
  return {
    type: ACTION_TYPES.ADD_QST_FAILED,
    category,
    error,
  };
}

export function updateQuestionStart(category, question) {
  return {
    type: ACTION_TYPES.UPDATE_QST_START,
    category,
    question,
  };
}

export function updateQuestionSuccessful(category, question) {
  return {
    type: ACTION_TYPES.UPDATE_QST_SUCCESSFUL,
    category,
    question,
  };
}

export function updateQuestionFailed(category, question, error) {
  return {
    type: ACTION_TYPES.UPDATE_QST_FAILED,
    category,
    question,
    error,
  };
}

export function deleteQuestionStart(category, question) {
  return {
    type: ACTION_TYPES.DELETE_QST_START,
    category,
    question,
  };
}

export function deleteQuestionSuccessful(category, question) {
  return {
    type: ACTION_TYPES.DELETE_QST_SUCCESSFUL,
    category,
    question,
  };
}

export function deleteQuestionFailed(category, question, error) {
  return {
    type: ACTION_TYPES.DELETE_QST_FAILED,
    category,
    question,
    error,
  };
}

// ========================================
// For user inetractions on question level:
// ========================================

export function editQuestion(category, question) {
  return {
    type: ACTION_TYPES.EDIT_QST,
    category,
    question,
  };
}

export function cancelQuestionEdit(category, question) {
  return {
    type: ACTION_TYPES.CANCEL_QST_EDIT,
    category,
    question,
  };
}

export function expandQuestion(category, question) {
  return {
    type: ACTION_TYPES.EXPAND_QST,
    category,
    question,
  };
}

export function collapseQuestion(category, question) {
  return {
    type: ACTION_TYPES.COLLAPSE_QST,
    category,
    question,
  };
}

export function addQuestion(category) {
  return (dispatch) => {
    dispatch(addQuestionStart(category));
    return popsss
      .postFormData('/faq/add_faq', {
        group_id: category.group_id,
      })
      .done((result) => {
        dispatch(addQuestionSuccessful(category, result.question));
      })
      .fail((error) => {
        dispatch(addQuestionFailed(category, error));
      });
  };
}

export function deleteQuestion(category, question) {
  return (dispatch) => {
    dispatch(deleteQuestionStart(category, question));
    return popsss
      .postFormData('/faq/delete_faq', {
        faq_id: question.faq_id,
      })
      .done(() => {
        dispatch(deleteQuestionSuccessful(category, question));
      })
      .fail((error) => {
        dispatch(deleteQuestionFailed(category, question, error));
      });
  };
}

export function saveQuestionEdit(category, question) {
  return (dispatch) => {
    dispatch(updateQuestionStart(category, question));
    return popsss
      .postFormData('/faq/update_faq', {
        faq_id: question.faq_id,
        question: question.question,
        answer: xss(question.answer),
      })
      .done(() => {
        dispatch(updateQuestionSuccessful(category, question));
        dispatch(cancelQuestionEdit(category, question));
      })
      .fail((error) => {
        dispatch(updateQuestionFailed(category, question, error));
      });
  };
}

export function publishQuestion(category, question) {
  return (dispatch) => {
    dispatch(updateQuestionStart(category, question));
    return popsss
      .postFormData('/faq/publish_faq', {
        faq_id: question.faq_id,
        unpublish: !question.publish,
      })
      .done(() => {
        dispatch(updateQuestionSuccessful(category, question));
      })
      .fail((error) => {
        dispatch(updateQuestionFailed(category, question, error));
      });
  };
}

export function makeQuestionGlobal(category, question) {
  return (dispatch) => {
    dispatch(updateQuestionStart(category, question));
    return popsss
      .postFormData('/faq/toggle_global', {
        faq_id: question.faq_id,
      })
      .done(() => {
        dispatch(updateQuestionSuccessful(category, question));
      })
      .fail((error) => {
        dispatch(updateQuestionFailed(category, question, error));
      });
  };
}
